import { render, staticRenderFns } from "./myGrant.vue?vue&type=template&id=4cd371a8&scoped=true"
import script from "./myGrant.vue?vue&type=script&lang=js"
export * from "./myGrant.vue?vue&type=script&lang=js"
import style0 from "./myGrant.vue?vue&type=style&index=0&id=4cd371a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd371a8",
  null
  
)

export default component.exports